export const office = ['检验科', '病理科', '急诊', '心内科', '心胸外科', '呼吸科', '感染科', '妇科', '产科', '消化科', '儿科', '骨科', '肿瘤科', '内分泌科', '普外科', '肾内科', '生殖中心', '神经内科', '影像科', '老年科', '其它']

export const position = ['主任医师', '主任技师', '副主任医师', '副主任技师', '主治医师', '住院医师', '主管技师', '技师', '其它']

export const department = ['医学部', '市场部', '销售部', '研发部', '其他部门']

export const part = ['总监', '部门经理', '专员', '职员/助理', '其它']
